module.exports = __webpack_public_path__ + "img/part3.c4b124e0.jpeg";